import { render, staticRenderFns } from "./SectionSidebar.vue?vue&type=template&id=f1390950&scoped=true"
import script from "./SectionSidebar.vue?vue&type=script&lang=js"
export * from "./SectionSidebar.vue?vue&type=script&lang=js"
import style0 from "./SectionSidebar.vue?vue&type=style&index=0&id=f1390950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1390950",
  null
  
)

export default component.exports